// Mettre votre JavaScript custom pour le site ici
// Mettre votre JavaScript custom pour le site ici
$(function() {

    $('.select-poste').click(function(e) {
        $('#postuler_poste').val($(this).data('poste'));
    });

});